



































































































































































































import { VueEditor, Quill } from 'vue2-editor';
import EditorMixins from '@/mixins/EditorMixins';
import { Component, Watch, Mixins, Ref } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';

import QuestionFormTypes from './QuestionFormTypes.vue';
import QuestionAnswerOptions from './QuestionAnswerOptions.vue';
import QuestionRawFormOptions from './QuestionRawFormOptions.vue';

import QuestionDependencyList from './QuestionDependencyList.vue';
import QuestionNegativeRuleList from './QuestionNegativeRuleList.vue';

import { RAW_FORM_OPTIONS } from '@/constants/question';
import { STATUSES } from '@/constants/question_group';

@Component({
  components: {
    VueEditor,
    QuestionFormTypes,
    QuestionAnswerOptions,
    QuestionRawFormOptions,
    QuestionDependencyList,
    QuestionNegativeRuleList,
  },
  computed: {
    ...mapState('Question', {
      question: 'question',
    }),
    ...mapState('QuestionGroup', {
      questionGroup: 'questionGroup',
    }),
  },
})
export default class QuestionFormFields extends Mixins(EditorMixins) {
  @Ref() readonly editor!: VueEditor;
  @Ref() readonly form!: { setErrors: (any?: any) => void };

  question!: {
    object_id: string;
    answer_options: [];
    raw_form_options: object[];
  };

  questionGroup!: Model;

  statuses = STATUSES;

  localQuestion: Model = {};

  isLoading = false;

  tab = 0;

  formTypesNeedAdditionalOptions = [
    'textinput',
    'textarea',
    'numberinput',
    'rangeslider',
    'datepicker',
    'datetimepicker',
    'body_parts',
  ];

  @Watch('localQuestion.form_type')
  watchType(newVal, oldVal) {
    // If oldVal is undefined, that means this watch function is triggered in localQuestion initialisation
    if (!oldVal) {
      return;
    }
    // If both oldVal and newVal are one of the options below, do not change the answer_options value
    const multipleOptionsTypes = [
      'radiobutton',
      'checkbox',
      'dropdown_single',
      'dropdown_multiple',
    ];
    if (
      multipleOptionsTypes.includes(oldVal) &&
      multipleOptionsTypes.includes(newVal)
    ) {
      return;
    }
    // Init option fields
    this.setOptionFields(newVal);
  }

  created() {
    // Clone the vuex state
    this.localQuestion = _.cloneDeep(this.question);

    // To set raw form options and answer options for old data
    if (
      !this.localQuestion.raw_form_options.length &&
      !this.localQuestion.answer_options.length
    ) {
      this.setOptionFields(this.localQuestion.form_type);
    } else {
      this.mergeMissingOptionFields(this.localQuestion.form_type);
    }

    // Init Media Library
    this.descEditorOptions.modules.toolbar.container.push(['image']);
    this.descEditorOptions.modules.toolbar.handlers['image'] = () => {
      this.mediaLibraryDialog = true;
    };
  }

  beforeDestroy() {
    if (this.question.object_id) {
      this.$store.commit('QuestionGroup/UPDATE_LIBRARY_ITEM', this.question);
    }
    this.$store.commit('Question/CLEAR_STATE');
  }

  handleSave() {
    this.save().finally(() => {
      this.isLoading = false;
    });
  }

  handleSaveClose() {
    this.save()
      .then(() => {
        this.$emit('close');
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  resetAnswerOptionsByType(type) {
    switch (type) {
      case 'textinput':
      case 'textarea':
      case 'numberinput':
      case 'rangeslider':
      case 'datepicker':
      case 'datetimepicker':
      case 'body_parts':
        this.localQuestion.answer_options = [];
        break;
    }
  }

  setOptionFields(type) {
    this.resetAnswerOptionsByType(type);

    if (_.has(RAW_FORM_OPTIONS, type)) {
      this.localQuestion.raw_form_options = RAW_FORM_OPTIONS[type];
    } else {
      this.localQuestion.raw_form_options = [];
    }
  }

  mergeMissingOptionFields(type) {
    this.resetAnswerOptionsByType(type);

    const currentRawFormOptions = this.localQuestion.raw_form_options;

    if (_.has(RAW_FORM_OPTIONS, type)) {
      const raw_form_options = RAW_FORM_OPTIONS[type];

      for (const option of raw_form_options) {
        if (
          !_.find(currentRawFormOptions, (o) => {
            return o.key == option.key;
          })
        ) {
          currentRawFormOptions.push(option);
        }
      }
    } else {
      this.localQuestion.raw_form_options = [];
    }

    Object.assign(currentRawFormOptions, this.localQuestion.raw_form_options);
  }

  save() {
    this.isLoading = true;

    // Vuex action is ‘create’ by default
    let action = 'Question/create';
    let payload: any = {
      ...this.localQuestion,
      question_group_oid: this.$route.params.questionGroupOid,
    };

    // Change Vuex action to update if the question is existed
    if (this.localQuestion.object_id) {
      action = 'Question/update';
      payload = {
        objectId: this.localQuestion.object_id,
        config: {
          ...this.localQuestion,
          question_group_oid: this.$route.params.questionGroupOid,
        },
      };
    }

    return this.$store.dispatch(action, payload).then((response) => {
      // Refresh local question data
      if (response.data.data.bridge) {
        // Create action will give question group impact target as the response
        this.localQuestion = _.cloneDeep(response.data.data.bridge);
      } else {
        this.localQuestion = _.cloneDeep(response.data.data);
      }
      this.$store.commit('SET_SNACKBAR', {
        show: true,
        type: 'success',
        message: 'The question is saved successfully.',
      });

      // Reload the candidate profile items
      this.$store.dispatch('CandidateProfile/fetchCandidateProfileItems');
    });
  }

  insertImage(image) {
    if (this.$options.filters) {
      this.mediaLibraryDialog = false;

      // Get cursor position in the editor
      const range = this.editor.quill.getSelection();
      const rangeIndex = range ? range.index : 0;
      console.debug(range);

      // Generate image uri
      const imageSrc = this.$options.filters.addressMediaFile(image);
      console.debug(imageSrc);

      // Insert Image
      this.editor.quill.insertEmbed(
        rangeIndex,
        'image',
        imageSrc,
        Quill.sources.USER
      );
    }
  }

  handleKeyCheck() {
    if (!this.localQuestion.candidate_profile_key.length) {
      return;
    }
    this.$store
      .dispatch('CandidateProfile/candidateProfileKeyCheck', {
        question_group_oid: this.questionGroup.object_id,
        question_oid: this.localQuestion.object_id || null,
        candidate_profile_key: this.localQuestion.candidate_profile_key,
      })
      .catch((error) => {
        if (error.response.data.error) {
          this.form.setErrors(error.response.data.error);
        }
      });
  }
}
